export default {
  title: 'Composición de Microaudiencia (%)',
  infoDialog: 'Seleccionar períodos para comparar la contribución al KPI de las 5 principales microaudiencias demográficas',
  selectWave: 'Seleccionar Período',
  projectedWave: 'Período Proyectado'
}
